<div
  class="card card-md border-0 available-account-balance
  {{ isLoading ? 'skeleton-loader' : 'loaded' }}
  {{ isEmployeeCardBalance() ? 'bg-secondary-subtle' : 'bg-secondary' }}"
  [ngClass]="{ 'text-white': !isEmployeeCardBalance() }">
  <div class="card-body align-content-center">
    <div class="row">
      <div class="col-auto">
        <div
          class="icon-rounded bg-white"
          [ngClass]="{ 'loading': isLoading, 'text-secondary': !isEmployeeCardBalance() }">
          @if (isEmployeeCardBalance()) {
            <i class="pays-svg-icon ic-card-app"></i>
          } @else {
            <i class="pays-svg-icon ic-card-2"></i>
          }
        </div>
      </div>
      <div class="col">
        <div>
          <div
            class="badge rounded-pill mb-1 {{ isEmployeeCardBalance() ? 'bg-dark' : 'bg-white text-dark' }}"
            [ngClass]="{ 'loading': isLoading }">
            {{ isEmployeeCardBalance() ? 'Employee' : 'Subscription' }} cards
          </div>
        </div>
        <div>
          <div
            class="fw-medium title"
            [ngClass]="{ 'loading': isLoading }">
            Total balance
          </div>
        </div>
        <div>
          @if (showError()) {
            <i class="small text-danger">Could not fetch balance</i>
          } @else {
            <div
              class="amounts"
              [id]="isEmployeeCardBalance() ? 'employeeCardBalance' : 'subCardBalance'"
              [ngClass]="{ 'loading min-w-100': isLoading }">
              @if (isEmployeeCardBalance()) {
                {{ accountBalance()?.total_physical | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
              } @else {
                {{ accountBalance()?.total_virtual | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
              }
            </div>
          }
        </div>
      </div>
    </div>
    @if (!showError()) {
      <hr />
      <div class="row">
        <div class="col-auto">
          <div class="app-card-balance-graph-wrapper">
            @if (isLoading) {
              <div class="circle-chart-124"></div>
            } @else {
              <div
                [id]="isEmployeeCardBalance() ? 'employeeCardBalancePercentage' : 'subscriptionCardBalancePercentage'"
                class="invisible">
                {{ isEmployeeCardBalance() ? allocationPercentagePhysical() : allocationPercentageVirtual() }}
              </div>
              <app-circle-graph
                baseColour="#F9F9FB"
                dataColour="#337CA6"
                [radius]="54"
                [strokeWidth]="18"
                [data]="
                  isEmployeeCardBalance() ? allocationPercentagePhysical() : allocationPercentageVirtual()
                "></app-circle-graph>
            }
          </div>
        </div>
        <div class="col">
          @if (!isLoading) {
            <div class="legend-chip unallocated"></div>
          }
          <div class="mb-3">
            <div class="fw-medium fs-5">
              @if (isEmployeeCardBalance()) {
                {{ accountBalance()?.balance_physical | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
              } @else {
                {{ accountBalance()?.balance_virtual | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
              }
            </div>
            <div
              [class.loading]="isLoading"
              [class.text-gray-500]="isEmployeeCardBalance()">
              Unallocated
            </div>
          </div>
          @if (!isLoading) {
            <div class="legend-chip on-cards"></div>
          }
          <div class="fw-medium fs-5">
            @if (isEmployeeCardBalance()) {
              {{ accountBalance()?.balance_physical_cards | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
            } @else {
              {{ accountBalance()?.balance_virtual_cards | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
            }
          </div>
          <a
            [routerLink]="isEmployeeCardBalance() ? '/cards/employee-cards' : '/cards/subscription-cards'"
            class="text-decoration-none text-reset"
            [class.loading]="isLoading"
            [class.text-gray-500]="isEmployeeCardBalance()">
            On cards <i class="iconoir-nav-arrow-right text-body"></i>
          </a>
        </div>
      </div>
    }
  </div>
</div>
